import React, { useContext } from "react";

import { Table, Thead, Tbody, Tr, Th } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import { UserContext } from '../contexts/index.jsx';
import { InfiniteScroll } from "./index.jsx";

const defaultFetchParams = {
  filters: {},
  sort: {
    field: "created_at",
    direction: "desc",
  },
};

const InfiniteTable = ({
  className = "",
  emptyText = "No results found.",

  data = [],
  fetchUrl,
  fetchParams,
  fetchLimit = 20,

  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  isInitialLoading = false,

  headers,
  RowComponent,
  responsive = true,
  onSelectClick,
  height,
  addLoggedUserFirst = false,
  firstPageOnly = false,
  rowComponentProps = {},
  scrollableTarget,
  onResultsLoaded,
  gateUntilSearch = false,
  minSearchLength = 0,
}) => {
  const { user } = useContext(UserContext);

  fetchParams = { ...defaultFetchParams, ...(fetchParams || {}) };

  const table = (headers, items) => {
    const body = items.map((item) => (
      <RowComponent
        item={item}
        key={item.id}
        onSelectClick={onSelectClick ? () => onSelectClick(item) : null}
        {...rowComponentProps}
      />
    ));

    const renderHeader = (content, i) => {
      const label = content && typeof content === "object" ? content.label : content;
      const thClass = content && typeof content === "object" ? content.className : undefined;
      return (
        <th key={i} className={thClass} style={{ textAlign: "left" }}>
          {label}
        </th>
      );
    };

    if (responsive) {
      return (
        <Table className={className}>
          <Thead>
            <Tr>
              {headers.map((content, i) => {
                const label = content && typeof content === "object" ? content.label : content;
                const thClass = content && typeof content === "object" ? content.className : undefined;
                return (
                  <Th key={i} className={thClass} style={{ textAlign: "left" }}>
                    {label}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>{body}</Tbody>
        </Table>
      );
    }

    return (
      <table className={className}>
        <thead>
          <tr>{headers.map(renderHeader)}</tr>
        </thead>
        <tbody>{body}</tbody>
      </table>
    );
  };

  return (
    <InfiniteScroll
      data={data}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      isInitialLoading={isInitialLoading}
      fetchUrl={fetchUrl}
      fetchParams={fetchParams}
      fetchLimit={fetchLimit}
      responsive={responsive}
      height={height}
      firstPageOnly={firstPageOnly}
      scrollableTarget={scrollableTarget}
      onResultsLoaded={onResultsLoaded}
      gateUntilSearch={gateUntilSearch}
      minSearchLength={minSearchLength}
    >
      {({ items, isLoading }) => {
        if (addLoggedUserFirst) {
          items = items.filter((item) => item.id != user.id);
        }

        if (addLoggedUserFirst && items?.[0]?.id != user.id) {
          items.unshift(user);
        }

        return (
          <>
            {items.length > 0 && table(headers, items)}

            {!isLoading && items.length === 0 && (
              <div className="no-results">
                <p>{emptyText}</p>
              </div>
            )}
          </>
        );
      }}
    </InfiniteScroll>
  );
};

export default InfiniteTable;
